document.addEventListener('DOMContentLoaded', () => {
  const counters = document.querySelectorAll('.number-counter');
  const speed = 100; // The higher the number, the slower the speed

  counters.forEach(counter => {
    const updateCount = () => {
      const target = +counter.getAttribute('data-target');
      const count = +counter.innerText;
      const increment = target / speed;

      if (count < target) {
        counter.innerText = Math.ceil(count + increment);
        setTimeout(updateCount, 1);
      } else {
        counter.innerText = target;
      }
    };

    updateCount();
  });
});